module.exports = __webpack_public_path__ + "img/btn_menu_lsjjr_c.47faf674.png";